import ProgramFeedView from 'components/views/ProgramFeedView';
import { routes } from 'defs';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getProgram } from 'store/dashboard';
import { getIsAuthenticated } from 'store/login';
import { getCoach, getIsAnamnesisDone, getLevel, getPoints } from 'store/profile';
import {
	getIsDayCheckable,
	getIsToday,
	getIsTodayAfterProgramm,
	getLastDayOfProgram,
	getStartDate,
} from 'store/programDays';
import {
	actionCreators as daysActionCreators,
	getDayByDayNumber,
	getIsDayInFuture,
	getOptionalItems,
	getTodayDayNumber,
} from 'store/programDays';
import { getItems } from 'store/programItems';
import {
	__getIsLastDay_DEPRECATED,
	actionCreators as programsAC,
	getCountActivePrograms,
	getFinishProgramData,
	getHasLoadedActivePrograms,
	getIsLastDay,
	getIsLoadingActivePrograms,
	getIsLoadingManualFinish,
	getNumberOfDays,
	getProgramTodayDayNumber,
} from 'store/programs';
import { actionCreators as tutorialActionCreators } from 'store/tutorial';
import { actionCreators as viewActionCreators, getHasViewError, getIsLoadingView } from 'store/view';

const mapStateToProps = (state, ownProps) => {
	const currentDayNumber = parseInt(ownProps.match.params.day, 10) || getTodayDayNumber(state) || 1;

	return {
		isLoadingView: getIsLoadingView(state, routes.today.indexRoute.id),
		isLoadingActivePrograms: getIsLoadingActivePrograms(state),
		isAuthenticated: getIsAuthenticated(state),
		isDayCheckable: getIsDayCheckable(
			state,
			getDayByDayNumber(state, ownProps.match.params.day || getTodayDayNumber(state))
		),
		isDayInFuture: getIsDayInFuture(state, ownProps.match.params.day || getTodayDayNumber(state)),
		isTodayAfterProgramm: getIsTodayAfterProgramm(state),
		isLoadingManualFinish: getIsLoadingManualFinish(state),
		isAnamnesisDone: getIsAnamnesisDone(state),
		cards: getItems(state, ownProps.match.params.day || getTodayDayNumber(state)),
		currentDayNumber,
		currentDay: getDayByDayNumber(state, ownProps.match.params.day || getTodayDayNumber(state)),
		numberOfDays: getNumberOfDays(state),
		todayDayNumber: getProgramTodayDayNumber(state),
		hasViewError: getHasViewError(state, routes.today.indexRoute.id),
		countActivePrograms: getCountActivePrograms(state),
		hasLoadedActivePrograms: getHasLoadedActivePrograms(state),
		isLastDay_DEPRECATED: !!__getIsLastDay_DEPRECATED(state),
		isLastDay: getIsLastDay(state, currentDayNumber),
		finishInfo: !!__getIsLastDay_DEPRECATED(state) ? getFinishProgramData(state) : void 0,
		coach: getCoach(state),
		optionalItems: getOptionalItems(state, currentDayNumber),
		isToday: getIsToday(state, currentDayNumber),
		program: getProgram(state),
		level: getLevel(state),
		levelPoints: getPoints(state),
		startDate: getStartDate(state),
		endDate: getLastDayOfProgram(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			...daysActionCreators,
			...viewActionCreators,
			doRequestFinishManually: programsAC.doRequestFinishManually,
			doTriggerTutorial: tutorialActionCreators.doTriggerTutorial,
		},
		dispatch
	);
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProgramFeedView as any));
